export enum BackendRoute {
  AUTH_LOGIN = '/auth/login',
  AUTH_LOGOUT = '/auth/logout',
  AUTH_RECOVER_PASSWORD = '/auth/recover-password',
  AUTH_REFRESH = '/auth/refresh',
  AUTH_REGISTER = '/auth/register',
  AUTH_TEMPORARY_ACCESS = '/auth/grant-temporary-access',
  AUTH_VALIDATE = '/auth/validate',
  BILLING = '/billing',
  CHECK_AUTH_TEMPORARY_ACCESS = '/auth/check-temporary-access',
  COMPANIES = '/companies',
  COUNTRIES = '/countries',
  CURRENCIES = '/currencies',
  DIVIDENDS = '/dividends',
  DIVIDENDS_DISTRIBUTION = '/dividends/distribution',
  DIVIDENDS_SHARE_CLASS_HOLDERS = '/dividends/share-class-holders',
  DIVIDENDS_STAKEHOLDER_PAYOUTS = '/dividends/stakeholder-payouts',
  DIVIDENDS_STAKEHOLDER_ROWS = '/dividends/stakeholder-rows',
  DIVIDENDS_STATS = '/dividends/stats',
  EVENTS = '/events',
  INVITATIONS = '/invitations',
  IP_INFO = '/ipinfo',
  PERKS = '/perks',
  PLANS = '/plans',
  POOLS = '/pools',
  RECOVERY = '/recovery',
  RECOVERY_CHECK = '/check-recovery',
  RECOVERY_RESEND = '/recovery/resend',
  SCENARIOS = '/scenarios',
  SHARE_CLASSES = '/share-classes',
  SHARE_PLANS = '/share-plans',
  SIGNATURES = '/signatures',
  SIGNATURES_LINKED_TARGET_OPTIONS = '/signatures/linked-target-options',
  SIGNATURES_QUICK_SIGN = '/signatures/quick-sign',
  SIGNATURES_REVOKED_ACCESS_SIGNERS = '/signatures/revoked-access-signers',
  STAKEHOLDERS = '/stakeholders',
  SUBSCRIPTION_OFFERS = '/subscription-offers',
  TEAM = '/stakeholders/team',
  TEMPLATES = '/templates',
  USERS = '/users',
  VERIFICATION = '/verification',
  VERIFICATION_REFRESH = '/verification/refresh',
}
